module.exports = __webpack_public_path__ + "img/xidao.prt.97798660.jpg";